/**
 * Branch week boundaries (29) 근무현황 / 급여대장 주차 라벨용.
 * weekStartWeekday: 1=월 … 7=일 (API `week_start_weekday`).
 */
export function getWeekRangeLabels(year: number, month: number, weekStartWeekday: number): string[] {
  const targetJSStartDay = weekStartWeekday === 7 ? 0 : weekStartWeekday;
  const current = new Date(year, month - 1, 1);
  while (current.getDay() !== targetJSStartDay) {
    current.setDate(current.getDate() - 1);
  }
  const ranges: string[] = [];
  for (let i = 0; i < 5; i++) {
    const startDay = current.getDate();
    const end = new Date(current);
    end.setDate(end.getDate() + 6);
    const endDay = end.getDate();
    ranges.push(`${i + 1}주차(${startDay}~${endDay})`);
    current.setDate(current.getDate() + 7);
  }
  return ranges;
}
